import React from 'react'
import { SectionContainer } from '../../../../styles/common.style'
import { MobileBackgroundImageLeft, MobileBackgroundImageRight } from '../../../../styles/MOBILE/MobileStyles'
import { HomeEventsSectionPictures } from '../../../../enums/images'
import MobileScrollingTextPrivate from './MobileScrollingTextPrivate'
import MobileScrollingTextPublic from './MobileScrollingTextPublic'

const MobileEventsSection: React.FC = () => {
  return (
    <SectionContainer>
        <MobileScrollingTextPrivate />
        <MobileBackgroundImageLeft src={HomeEventsSectionPictures.PrivateEventsPicture} alt="Private Events" />
        <MobileBackgroundImageRight src={HomeEventsSectionPictures.PublicEventsPicture} alt="Public Events" />
        <MobileScrollingTextPublic />
    </SectionContainer>
  )
}

export default MobileEventsSection